var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-markdown',[_vm._v("\n#### 开发文档\n\n部分接口[在此](https://fzlee.gitbooks.io/goods/content/)\n\n\n####  重复订单的处理\n  如果订单进入了拼板以及之后的流程，且再次收到了第三方公司的同样订单，我们将会直接拒绝接受这个订单。\n  如果订单位于拼板之前的流程， 我们会立即更新这个订单的信息以及文件。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }